import { type Getter, type Setter } from 'jotai'

import {
  availFilterTypesAtom,
  defaultFiltersQuery,
  filtersQueryAtom,
} from 'Pages/unifiedFiltersListPage/state/state'
import { type FilterType } from 'Types/beFiltersApi'
import { searchFilters } from './filters'

export const changeFilterTypesCallback = (
  _: Getter,
  set: Setter,
  v: FilterType[],
): void => {
  set(filtersQueryAtom, (prev) => ({
    ...prev,
    types: v,
  }))
}

export const toggleAllFilterTypesCallback = (_: Getter, set: Setter): void => {
  set(filtersQueryAtom, (prev) => ({
    ...prev,
    allTypes: !prev.allTypes,
  }))
}

export const toggleAllCategoriesCallback = (_: Getter, set: Setter): void => {
  set(filtersQueryAtom, (prev) => ({
    ...prev,
    allCategories: !prev.allCategories,
  }))
}

export const resetSearchCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  const availFilterTypes = get(availFilterTypesAtom)

  set(filtersQueryAtom, {
    ...defaultFiltersQuery,
    types: availFilterTypes.map((t) => t.value),
  })
  await searchFilters(get, set)
}
